"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const config_1 = require("@completeanatomy/config");
const index_1 = require("../index");
function GroupDetails({ group, className, isMobile }) {
    const config = (0, config_1.useConfigService)();
    const baseImageUrl = (config === null || config === void 0 ? void 0 : config.get('AWS_SERVER_S3_USERDATA')) || '';
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'GroupDetails_Container', children: [(0, jsx_runtime_1.jsxs)(InfoContainer, { "data-e2e": 'GroupDetails_InfoContainer', children: [(0, jsx_runtime_1.jsx)(GroupAvatar, { image: group.avatar ? baseImageUrl + group.avatar : '', "$isMobile": isMobile, group: true, "data-e2e": 'GroupDetails_GroupAvatar' }), (0, jsx_runtime_1.jsx)(Name, { "data-e2e": 'GroupDetails_Name', children: group.name })] }), (0, jsx_runtime_1.jsxs)(ItemsContainer, { "data-e2e": 'GroupDetails_ItemsContainer', children: [!!group.membersCount && ((0, jsx_runtime_1.jsx)(index_1.GroupDetailsItem, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.members), count: group.membersCount, "data-e2e": 'GroupDetails_GroupDetailsItem' })), !!group.quizzesCount && ((0, jsx_runtime_1.jsx)(index_1.GroupDetailsItem, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.quizzes), count: group.quizzesCount, "data-e2e": 'GroupDetails_GroupDetailsItem' })), !!group.questionsCount && ((0, jsx_runtime_1.jsx)(index_1.GroupDetailsItem, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.questions), count: group.questionsCount, "data-e2e": 'GroupDetails_GroupDetailsItem' })), !!group.screensCount && ((0, jsx_runtime_1.jsx)(index_1.GroupDetailsItem, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.screens), count: group.screensCount, "data-e2e": 'GroupDetails_GroupDetailsItem' })), !!group.recordingsCount && ((0, jsx_runtime_1.jsx)(index_1.GroupDetailsItem, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.videos), count: group.recordingsCount, "data-e2e": 'GroupDetails_GroupDetailsItem' })), !!group.coursesCount && ((0, jsx_runtime_1.jsx)(index_1.GroupDetailsItem, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.courses), count: group.coursesCount, "data-e2e": 'GroupDetails_GroupDetailsItem' })), !!group.lecturesCount && ((0, jsx_runtime_1.jsx)(index_1.GroupDetailsItem, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.lectures), count: group.lecturesCount, "data-e2e": 'GroupDetails_GroupDetailsItem' }))] })] }));
}
exports.default = GroupDetails;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  max-width: 100%;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    flex-direction: column;
    margin: 0 20px;
  `)}

  ${ui_1.device.tablet((0, styled_components_1.css) `
    flex-direction: column;
  `)}
`;
const InfoContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    flex-basis: 40%;
    align-items: center;

    margin: auto 0;
  `)}
`;
const GroupAvatar = (0, styled_components_1.default)(ui_1.Avatar) `
  width: 100px;
  height: 100px;

  margin: ${({ $isMobile }) => ($isMobile ? '10px auto' : '80px auto 0 auto')};

  color: ${props => props.theme.sharing.avatar.fill};

  background-color: ${props => props.theme.sharing.avatar.background};

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin: 0 auto;
  `)}
`;
const Name = (0, styled_components_1.default)(ui_1.TruncatedText) `
  max-width: 90%;
  margin: 20px auto 0 auto;

  color: ${props => props.theme.text};
  font-size: 18px;
  text-align: center;

  ${ui_1.device.mobileL((0, styled_components_1.css) `
    margin-bottom: 20px;
  `)}

  ${ui_1.device.tablet((0, styled_components_1.css) `
    margin-bottom: 20px;
  `)}
`;
const ItemsContainer = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  margin: 60px 30px 0 30px;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    flex-basis: 60%;

    margin: auto;
  `)}

  ${ui_1.device.tablet((0, styled_components_1.css) `
    flex-basis: unset;

    max-width: 400px;

    margin: 60px 30px 0 30px;
  `)}
`;
